import { Button } from "@progress/kendo-react-buttons";
import { ProgressBar } from "@progress/kendo-react-progressbars";
import EmptyState from "../components/common/EmptyState";
import { formatCurrency, formatDate } from "../utils/formatters";

export default function Goals({ currencyCode, goals, locale, onAdd, onDelete, onEdit, onReorder, t = {} }) {
  return (
    <div className="page-stack">
      <section className="toolbar-panel">
        <div>
          <p className="eyebrow">{t.goals || "Goals"}</p>
          <h2>{t.financialTargets || "Financial targets"}</h2>
        </div>
        <Button themeColor="primary" icon="plus" onClick={onAdd}>
          {t.addGoal || "Add goal"}
        </Button>
      </section>

      {goals.length ? (
        <section className="goal-grid">
          {goals.map((goal) => (
            <article
              className="goal-card draggable-card"
              draggable
              key={goal.id}
              onDragOver={(event) => event.preventDefault()}
              onDragStart={(event) => {
                event.dataTransfer.effectAllowed = "move";
                event.dataTransfer.setData("text/plain", goal.id);
              }}
              onDrop={(event) => {
                event.preventDefault();
                const sourceId = event.dataTransfer.getData("text/plain");
                if (sourceId && sourceId !== goal.id) {
                  onReorder(sourceId, goal.id);
                }
              }}
            >
              <div className="goal-card-header">
                <div>
                  <h3>{goal.title}</h3>
                  {goal.description && <p>{goal.description}</p>}
                </div>
                <div className="row-actions">
                  <Button fillMode="flat" icon="edit" onClick={() => onEdit(goal)}>
                    {t.edit || "Edit"}
                  </Button>
                  <Button fillMode="flat" themeColor="error" icon="delete" onClick={() => onDelete(goal.id)}>
                    {t.delete || "Delete"}
                  </Button>
                </div>
              </div>
              <ProgressBar value={goal.progress} />
              <div className="goal-meta">
                <span>
                  {formatCurrency(goal.currentAmount, currencyCode, locale?.localeCode)} / {formatCurrency(goal.targetAmount, currencyCode, locale?.localeCode)}
                </span>
                <span>{goal.daysRemaining > 0 ? (t.daysLeft || ((days) => `${days} days left`))(goal.daysRemaining) : t.targetDatePassed || "Target date passed"}</span>
                <span>{(t.target || ((date) => `Target: ${date}`))(formatDate(goal.targetDate, locale?.localeCode))}</span>
              </div>
            </article>
          ))}
        </section>
      ) : (
        <section>
          <EmptyState
            actionLabel={t.createFirstGoal || "Create first goal"}
            description={t.emptyHint || "Create a target and track progress beside everyday spending."}
            icon="k-i-check-target"
            onAction={onAdd}
            title={t.noGoalsYet || "No goals yet"}
          />
        </section>
      )}
    </div>
  );
}
